import { tsUtils } from '@neo-one/ts-utils';
export const hasString = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isString(context, node, tpe));
export const isOnlyString = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isString(context, node, tpe));
export const isString = (_context, _node, type) => tsUtils.type_.isStringish(type);

//# sourceMappingURL=typeTests.js.map
